export default String.raw`
.dialog {
    width: 100%;
    margin: auto 0 0 0;
    max-width: 100%;
    min-width: unset;
    border-bottom-left-radius: 0;
    border-bottom-right-radius: 0;

    &__header {
        padding: 16px 16px 0px 16px;
    }
}

body:has(dialog[open]) {
    overflow: hidden;
}

.popup.rendered-dialog {
    padding: 16px 8px 16px 16px;

    .popup__content {
        padding-right: 8px;
    }

    .popup__buttons {
        padding-right: 8px;
    }
}

.popup-background{
    z-index: 1002;
}

.popup-info {
    right: 50vw;
    margin-right: -150px;

    @media screen and (max-width: 300px) {
        right: 0;
        margin-right: 10px;
    }
}

.technical-break {
    margin: 32px 16px 0 16px;
    display: flex;
    flex-direction: column;
    gap: 32px;

    .content {
        font-size: 24px;
        font-weight: 500;
        line-height: 32px;
        margin-bottom: 16px;
        align-items: center;

        &__info {
            margin: 0;
            text-align: center;
            max-width: 520px;
        }

        img {
            align-items: center;
        }

        &__mobile {
            display: block;
            width: 300px;
            height: 300px;
        }
    }

    &__image {
        display: none;
    }
}

.cookie-message-opener {
    bottom: 75px;
    left: 10px;
}

.cookie-container-background {
    align-items: flex-end;
}

.cookie-container {
    max-width: none;
    border-radius: 12px 12px 0 0;
    &__btn-wrapper {
        flex-direction: column-reverse;
    }
    &__btn.secondary-action-button {
        margin-right: 0;
    }
}

.go-to-top-button {
    bottom: 75px;
}

.notice-container {
    &__btn-wrapper {
        justify-content: space-between;

        .secondary-action-button {
            margin: 0;
        }

        .primary-action-button {
            padding: 8px 8px;
        }
    }
}
`